// Задаем null, undefined полям объекта значение false
// Универсальная карточка ожидает явные значения
export const replaceFalsyWithFalse = (obj) => {
  Object.keys(obj).forEach((key) => {
    obj[key] = obj[key] ?? false
  })
  return obj
}
